import { render, staticRenderFns } from "./embed.vue?vue&type=template&id=565ddd4e"
import script from "./embed.vue?vue&type=script&lang=js"
export * from "./embed.vue?vue&type=script&lang=js"
import style0 from "./embed.vue?vue&type=style&index=0&id=565ddd4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports